'use client';

import React, { useEffect, useRef } from "react";
import LocationPopup from "./LocationPopup";
import { useAppDispatch, useAppSelector } from "@/hotdesk-ui/hooks/hook";
import { RootState } from "@/hotdesk-ui/store/store";
import { fetchGeoLocation, fetchLocationAPI, setGeoLocation, toggelLocationPopup } from "@/hotdesk-ui/store/slices/geo-location.slice";
import { setCurrentSearch } from "@/hotdesk-ui/store/slices/search.slice";
import { getListingData, getWorkspaceData, setListingPage, setWorkspacePage } from "@/hotdesk-ui/store/slices/listing.slice";
import { unwrapResult } from "@reduxjs/toolkit";
const LocationPopupClient = () => {
  const dispatch = useAppDispatch();
  const showLocationModal = useAppSelector((state: RootState) => state.geoLocation.showLocationModal);
  const geoSource = useAppSelector((state: RootState) => state.geoLocation.geoLocationZipData?.source);

  // Keep the latest source available to the (stable) permission-change
  // listener without re-subscribing it on every source change.
  const geoSourceRef = useRef(geoSource);
  geoSourceRef.current = geoSource;
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('permissions' in navigator)) return;
    let status: PermissionStatus | null = null;
    const handleChange = () => {
      if (status?.state !== 'granted') return;
      if (!('geolocation' in navigator)) return;
      // The user explicitly searched a place (e.g. "London"). Granting
      // location permission must not hijack that search with "Nearby" —
      // an explicit search always wins. Just dismiss the popup.
      if (geoSourceRef.current === 'autocomplete') {
        dispatch(toggelLocationPopup(false));
        return;
      }
      navigator.geolocation.getCurrentPosition(async ({
        coords
      }) => {
        try {
          const result = unwrapResult(await dispatch(fetchLocationAPI({
            latitude: coords.latitude,
            longitude: coords.longitude
          })));
          dispatch(setGeoLocation(result));
          dispatch(setCurrentSearch(result));
          dispatch(setWorkspacePage(1));
          dispatch(setListingPage(1));
          dispatch(getListingData({
            lastSearch: result,
            page: 1
          }));
          dispatch(getWorkspaceData({
            lastSearch: result,
            page: 1
          }));
        } catch {}
      }, () => {});
      dispatch(toggelLocationPopup(false));
    };
    navigator.permissions.query({
      name: 'geolocation' as PermissionName
    }).then(s => {
      status = s;
      status.addEventListener('change', handleChange);
    }).catch(() => {});
    return () => {
      status?.removeEventListener('change', handleChange);
    };
  }, [dispatch]);
  const getLocation = () => {
    dispatch(fetchGeoLocation());
    dispatch(toggelLocationPopup(false));
  };
  const handleClose = () => {
    dispatch(toggelLocationPopup(false));
  };
  return <LocationPopup show={showLocationModal} handleClose={handleClose} getLocation={getLocation} data-sentry-element="LocationPopup" data-sentry-component="LocationPopupClient" data-sentry-source-file="LocationPopupClient.tsx"></LocationPopup>;
};
export default LocationPopupClient;